// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gY2z","question":"styles_question__1CHLy","description":"styles_description__12p5w"};